import { all_information } from '../App';
import { getMyOrganizations } from '../services/Users/Users';

export interface OrgOption {
  id: string;
  name: string;
}

export const loadOrganizationOptions = async (): Promise<OrgOption[]> => {
  if (!all_information?.token) return [];
  const res: any = await getMyOrganizations(all_information.token);
  return (res?.data ?? []).map((o: any) => ({
    id: String(o.organization_id),
    name: o.organization_name || o.organization_code || `Org #${o.organization_id}`,
  }));
};